import { motion } from 'framer-motion';

/**
 * Masked line-by-line reveal for headline lines.
 * lines: array of strings, or arrays of {text, className} for per-line styling.
 */
export default function RevealText({ lines = [], as: Tag = 'h1', className = '', lineClassName = '', delay = 0, testId }) {
  return (
    <Tag data-testid={testId} className={className}>
      {lines.map((line, i) => {
        const text = typeof line === 'string' ? line : line.text;
        const extra = typeof line === 'string' ? '' : (line.className || '');
        return (
          <span key={i} className="reveal-mask block">
            <motion.span
              className={`block ${lineClassName} ${extra}`}
              initial={{ y: '110%' }}
              animate={{ y: '0%' }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: delay + i * 0.09 }}
            >
              {text}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}
